import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { fetchConfig } from './api.utils';

export interface AttributeValuesResponseDto {
  values: Record<string, string[]>;
}

interface UseAnalyticsAttributeValuesParams {
  publisherId?: string;
  attributeNames: string[];
  startDate: string;
  endDate: string;
}

export function useAnalyticsAttributeValues({ 
  publisherId, 
  attributeNames,
  startDate, 
  endDate 
}: UseAnalyticsAttributeValuesParams) {
  const axios = useAxios();

  return useQuery({
    ...fetchConfig.general,
    queryKey: [`${EQueryKeys.ANALYTICS_ATTRIBUTES}_VALUES_${startDate}_${endDate}_${attributeNames.join('_')}`],
    queryFn: async (): Promise<AttributeValuesResponseDto> => {
      if (!startDate || !endDate || attributeNames.length === 0) {
        return { values: {} };
      }

      const data = await axios.get(
        '/dashboard/analytics/attributes/values',
        {
          attributeNames,
          startDate,
          endDate
        },
        publisherId ? { 'x-publishers': publisherId } : undefined
      );

      return data;
    },
    enabled: !!publisherId && attributeNames.length > 0 && !!startDate && !!endDate
  });
} 